import { uniqueId } from "lodash";
import { useState } from "react";

const Checkbox = ({ checked, onChange, label, id, disabled, name, size }) => {
  const handleChange = (e) => {
    onChange(e.target.checked);
  };

  const [checkboxId] = useState(id || uniqueId("checkbox-"));

  const sizeStyle =
    size === "lg" ? { width: "20px", height: "20px", cursor: disabled ? "not-allowed" : "pointer" } : {};

  return (
    <div className="checkbox-content d-flex flex-nowrap align-items-center">
      <input
        className={`form-check-input mb-1${label ? " me-2" : ""}`}
        type="checkbox"
        name={name}
        id={checkboxId}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        style={sizeStyle}
      />
      {label && (
        <label htmlFor={checkboxId} className={`${disabled ? "text-muted" : ""}`}>
          {label}
        </label>
      )}
    </div>
  );
};
export default Checkbox;
